const pt = {
  "hotel.folio.guest": "Hóspedes",
  "hotel.folio.guest.name": "Nome",
  "hotel.folio.guest.birthday": "Data de nascimento",
  "hotel.folio.guest.id_number": "Número de identificação",
  "hotel.folio.guest.sex": "Sexo",
  "hotel.folio.guest.nationality": "Nacionalidade",
  "hotel.folio.guest.target_country": "País de destino",
  "hotel.folio.guest.email": "E-mail",
  "hotel.folio.guest.Nombres": "Nome completo",
  "hotel.folio.guest.typeDocument": "Tipo de documento",
  "hotel.folio.guest.type_accomodation": "Tipo de acomodação",
  "hotel.folio.guest.room": "Quarto",
  "hotel.folio.guest.phone": "Telefone",
  "hotel.folio.guest.arrival_date": "Data de check-in",
  "hotel.folio.guest.departure_date": "Data de check-out",
  "hotel.folio.guest.nights_quantity": "Número de noites",
  "hotel.folio.guest.unit_price": "Tarifa / Preço unitário",
  "hotel.folio.guest.payment_status": "Status do pagamento",
  "hotel.folio.guest.channel": "Canal de reserva",
  "hotel.folio.guest.reason": "Motivo da viagem",
  "hotel.folio.guest.Tipo de Ocupante": "Tipo de ocupante",
  "hotel.folio.guest.company": "Empresa",
  "hotel.folio.guest.Identificación Empresa": "Identificação da empresa",
  "hotel.folio.guest.vehicle_plate": "Placa do veículo",
  "hotel.folio.guest.adult": "Adulto",
  "hotel.folio.guest.child": "Criança",
  male: "Masculino",
  female: "Feminino",
  "hotel.folio.guest.main_guest": "Hóspede principal",
  "hotel.folio.guest.type_guest": "Tipo de hóspede",
  "hotel.folio.guest.type_document": "Tipo de documento",
  "hotel.folio.guest.mobile": "Celular",
  "hotel.folio.guest.address": "Endereço",
  "hotel.folio.guest.origin_country": "País de origem",
  "hotel.folio.guest.notes": "Observações",
  "hotel.folio.guest.registro_civil": "Registro civil de nascimento",
  "hotel.folio.guest.tarjeta_identidad": "Carteira de identidade",
  "hotel.folio.guest.cedula_ciudadania": "Documento de cidadania",
  "hotel.folio.guest.tarjeta_extranjeria":
    "Carteira de identidade de estrangeiro",
  "hotel.folio.guest.cedula_extranjeria": "Documento de cidadania estrangeira",
  "hotel.folio.guest.nit": "Número de identificação fiscal (NIT)",
  "hotel.folio.guest.add_guest": "Adicionar",
  "hotel.folio.guest.cancel": "Cancelar",
  "hotel.folio.guest.pasaporte": "Passaporte",
  "hotel.folio.guest.tipo_documento_extranjero":
    "Tipo de documento estrangeiro",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "Número fiscal estrangeiro (NIT)",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "País",
  "hotel.folio.guest.subdivision": "Subdivisão",
  "hotel.booking.link_web_checkin": "Link de check-in",
  "hotel.folio.guest.city_co": "Cidade",
  "hotel.folio.guest.foreign_city": "Cidade estrangeira",
  "hotel.folio.guest.welcome_tra":
    "Vamos assinar a Ficha de Registro de Hospedagem (FRH)",
  "hotel.folio.guest.hello": "Olá",
  hotel_tra_register_card: "Ficha de Registro de Hospedagem (FRH)",
  "msg-introduction": "Vamos assinar a Ficha de Registro de Hospedagem (FRH).",
  "hotel.folio.guest.title-modal-select-lan": "Selecionar idioma",
  "hotel.folio.guest.btn_finish": "FINALIZAR",

  "hotel.folio.guest.content_guest": "Hóspedes",
  "hotel.folio.guest.content_info_folio": "Informações do hóspede principal",
  "hotel.folio.guest.content_contract": "Contrato de hospedagem",
  "hotel.folio.guest.content_signature": "Assinatura digital",
  "hotel.folio.guest.terms_and_conditions1":
    "Li e aceito os termos e condições do contrato de hospedagem",
  "hotel.folio.guest.terms_and_conditions2":
    " e a política de tratamento de dados pessoais do estabelecimento",
  "hotel.folio.guest.guests_no_found": "Nenhum hóspede encontrado",
  "hotel.folio.guest.accept_contract":
    "Você precisa aceitar o contrato de hospedagem",
  "hotel.folio.signature.updated": "Assinatura atualizada com sucesso",
  "hotel.folio.guest.finish": "Bem-vindo ao hotel!",
  "hotel.folio.guest.finish_tra": "Obrigado por se registrar de forma digital!",
  "hotel.folio.guest.finish_description":
    "Com este pequeno gesto, você ajudou a reduzir o uso de papel e a cuidar do planeta. Cada ação conta.",
  "app.webcheckin.melhos.use_app":
    "Você pode usar nosso App! O melhor é que não precisa baixar nada 😎",
};
export default pt;
